import { makeStyles } from "@material-ui/core"

export const vendorContactStyle = makeStyles((theme) => ({
    collapseWrapper: {
    },
    review: {
        boxShadow: '1px 2px 7px #ddd',
        mariginTop: '01em',
        padding: '0.5em 0',
        padding: '1em',
        borderRadius: '5px',
        position: 'relative'
    },
    reviewsTitle: {
        fontWeight: 'bold',
        marginBottom: '1em',
        color: theme.palette.primary.dark,
    },
    contactText: {
        fontWeight: 'bold'
    },
    detailsButton: {
        width: '100%',
        justifyContent: 'end'
    },
    contactListContainer: {
        marginTop: '1em',
        marginBottom: '1em',
        border: '1px solid #ddd',
        borderRadius: '5px',
        padding: '1em',
    },
    contactItem: {
        mariginTop: '1em',
        padding: '1em',
        border: '1px solid #ddd',
        borderRadius: '5px',
        position: 'relative'
    },
    contactType: {
        marginBottom: '0.5em',
        backgroundColor: '#80dc34',
        borderRadius: '20px',
        textAlign: 'center',
        fontSize: '0.7em',
        fontWeight: '500',
        padding: '3px 10px',
        whiteSpace: 'nowrap',
        width: 'fit-content',
        marginRight: '1em',
    },
    primaryContactLabel: {
        marginLeft: '0.5em',
    },
    contactPocType: {
        marginBottom: '0.5em',
        backgroundColor: '#ffd900ff',
        borderRadius: '20px',
        textAlign: 'center',
        fontSize: '0.7em',
        fontWeight: '500',
        padding: '3px 10px',
        whiteSpace: 'nowrap',
        width: 'fit-content',
    },
    types: {
        display: 'flex',
    }
}));